/**
 * Page utilities
 */
export class Page {

    /** Purpose: return the page href. Necessary to enable mocking of page URL for unit testing
     *
     * @return {String} Value value of document.location.href
     * */
    static getLocationHref() {
        return window.location.href;
    }

    /** Purpose: set page href. Necessary to enable mocking of page URL for unit testing
     * */
    static setLocationHref(url) {
        window.location.href = url;
    }

    /** Purpose: return the page search. Necessary to enable mocking of page URL for unit testing
     *
     * @return {String} Value value of document.location.search
     * */
    static getLocationSearch() {
        return window.location.search;
    }

    /** Purpose: return the page pathname. Necessary to enable mocking of page URL for unit testing
     *
     * @return {String} Value value of document.location.pathname
     * */
    static getLocationPathname() {
        return window.location.pathname;
    }

    /** Purpose: return the page hostname. Necessary to enable mocking of page URL for unit testing
     *
     * @return {String} Value value of document.location.hostname
     * */
    static getLocationHostname() {
        return window.location.hostname;
    }

    static getQuerystring(param) {
        return new RegExp(`[?&]+${param}=([^&$]*)`, 'gi').test(Page.getLocationHref()) ? RegExp.$1 : '';
    }
}
